type scalars = 'string' | 'number' | 'bigint' | 'boolean' | 'symbol' | 'undefined' | 'object' | 'function';

export const extractMessageField = (input: object, keyName: string, keyType?: scalars) => {
  if (!input) {
    return null;
  }

  if (Object.hasOwn(input, keyName)) {
    const value = input[keyName as keyof typeof input];
    if (!keyType || keyType === typeof value) {
      return value;
    }
  }

  const entries = Object.entries(input);
  let result: null | unknown = null;
  entries.forEach(entry => {
    if (typeof entry[1] === 'object') {
      const subtreeResult = extractMessageField(entry[1], keyName, keyType);

      if (subtreeResult !== null) {
        result = subtreeResult;
      }
    }
  });

  return result;
};
